import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzCascaderFilter } from 'ng-zorro-antd/cascader';
import {
  ProjectItemType,
  ProjectItemTypeIndexList,
} from '../../models/project/project-item-type.enum';
import { ProjectSectionItem } from '../../models/project/project-section-item.model';
import { ProjectSection } from '../../models/project/project-section.model';
import { OrganizationType } from '../../models/staff/organization-type.enum';
import { NzTreeNode } from '../../models/tree-node.model';
import { EventService, EventType } from '../../providers/event.service';
import { GlobalService } from '../../providers/global.service';

@Component({
  selector: 'wbs-unit-cascader',
  templateUrl: './wbs-unit-cascader.component.html',
  styleUrls: ['./wbs-unit-cascader.component.scss'],
})
export class WbsUnitCascaderComponent {
  isBeamUser = false;

  async onChange() {
    const section = await this.globalService.getWbsTreeRoot();
    const sectionIds: number[] = [];
    for (const item of this.globalService.userInfo.projectSections ?? []) {
      if (item.sectionType !== this.sectionType) {
        continue;
      }

      if (this.stage !== 0 && item.stage !== this.stage) {
        continue;
      }
      // console.log(item);
      if (this.sectionType === OrganizationType.CONSTRUCTION) {
        if (!this.isBeamUser && item.beamYardSectionTag) {
          continue;
        }
        if (
          this.isBeamUser &&
          this._type !== ProjectItemType.SECTION &&
          item.beamYardSectionTag
        ) {
          continue;
        }
      }
      sectionIds.push(item.sectionId!);
    }
    const treeNodes: NzTreeNode[] = [];
    for (const item of section?.child ?? []) {
      if (
        !sectionIds.includes(item.sectionId!) &&
        this.globalService.userInfo.organizationType !==
          OrganizationType.OPERATE
      ) {
        continue;
      }
      let filteBeamYard = false;
      if (this.sectionType === OrganizationType.CONSTRUCTION) {
        for (const section of this.globalService.userInfo.projectSections ??
          []) {
          if (`${item.sectionId}` === `${section.sectionId}`) {
            filteBeamYard = !!section.beamYardSectionTag;
            break;
          }
        }
        if (!item.includeBeamYard && filteBeamYard) {
          continue;
        }
      }
      treeNodes.push(
        this.buildTreeNodes(
          item,
          this.type ?? ProjectItemType.SECTION,
          '',
          filteBeamYard,
        ),
      );
    }
    this.unitTreeNodes = treeNodes;
  }

  subsciption = () => this.onChange();

  @Input()
  set unitCascaderValue(value: any[]) {
    this._unitCascaderValue = value;
  }

  get unitCascaderValue(): any[] {
    return this._unitCascaderValue;
  }

  @Input()
  set sectionItemId(value: number | undefined) {
    if (value) {
      setTimeout(() => {
        const found = this.searchNode(`${value}`, {
          value: 'root',
          children: this.unitTreeNodes,
        } as NzTreeNode);
        if (found) {
          this.unitCascaderValue = found.slice(1);
          this.onUnitCascaderValueChange();
        }
      }, 1000);
    }
  }

  private _type: ProjectItemType = ProjectItemType.SECTION;

  @Input()
  set type(value: ProjectItemType) {
    if (!value) {
      value = ProjectItemType.SECTION;
    }
    this._type = value;
  }

  get type(): ProjectItemType {
    return this._type;
  }

  private _sectionType: OrganizationType = OrganizationType.CONSTRUCTION;

  @Input()
  set sectionType(value: OrganizationType) {
    this._sectionType = value;
  }

  get sectionType(): OrganizationType {
    return this._sectionType;
  }

  @Input()
  disabled = false;

  _unitCascaderValue: any[] = [];

  @Output() unitCascaderValueChange = new EventEmitter<any[]>();

  unitTreeNodes: NzTreeNode[] = [];

  sections: ProjectSection[] = [];

  @Input()
  stage: number = 0;

  @Input()
  hasAll = false;

  constructor(
    private globalService: GlobalService,
    private events: EventService,
  ) {
    this.isBeamUser = !!this.globalService.hasBeam;
  }

  ngOnInit(): void {
    this.events.on(EventType.WbsTitleChangeEvent, this.subsciption);
    this.onChange();
  }

  ngOnDestroy(): void {
    this.events.destroyListener(
      EventType.WbsTitleChangeEvent,
      this.subsciption,
    );
  }

  onUnitCascaderValueChange() {
    if (this._unitCascaderValue.length !== 0) {
      this.unitCascaderValueChange.emit(this._unitCascaderValue);
    }
  }

  onUnitCascaderClear() {
    this.unitCascaderValue = [];
    this.onUnitCascaderValueChange();
  }

  searchNode(value: string, node: NzTreeNode): string[] | null {
    if (`${node.value}` === value) {
      return this.hasAll ? [node.value, node.value] : [node.value];
    }
    for (const child of node.children ?? []) {
      const found = this.searchNode(value, child);
      if (found) {
        return [node.value, ...found];
      }
    }
    return null;
  }

  private buildTreeNodes(
    item: ProjectSectionItem,
    type: ProjectItemType,
    sortValue: string,
    filterBeam?: boolean,
  ): NzTreeNode {
    const sort = sortValue + item.name;
    const node: NzTreeNode = {
      label:
        item.type === ProjectItemType.PROJECT_SECTION
          ? item.name
          : (item.code ?? '') + ' ' + item.name,
      value: item.id,
      sort,
      children: [],
      isLeaf: false,
      hasBeam: !!item.includeBeamYard,
    };
    if (
      item.child?.length === 0 ||
      ProjectItemTypeIndexList.indexOf(type) <=
        ProjectItemTypeIndexList.indexOf(item.type!)
    ) {
      node.isLeaf = true;
      node.children = undefined;
    } else {
      for (const child of item.child ?? []) {
        if (filterBeam && !child.includeBeamYard) {
          continue;
        }
        node.children!.push(this.buildTreeNodes(child, type, sort, filterBeam));
      }
      if (node.children!.length === 0) {
        node.isLeaf = true;
        node.children = undefined;
      } else {
        if (this.hasAll) {
          node.children!.unshift({
            label: '全部',
            value: item.id,
            sort: sort + '全部',
            isLeaf: true,
          });
        }
      }
    }
    return node;
  }

  filter: NzCascaderFilter = (i, path) => {
    return path.some((o) => {
      if (i.length < 2) {
        return false;
      }
      if (!o.isLeaf) {
        return false;
      }
      const label = o['sort'] as string;
      return !!label && label.indexOf(i) !== -1;
    });
  };
}
